import * as req from 'api/actions';
import * as c from './constant';

export const getList = (payload, callback) =>
  req.list(
    c.GET_LIST,
    '/api/v1/administrators/special_permits/pdf_settings',
    payload,
    callback
  );

export const updatePdf = (payload, callback) => req.update(
  c.UPDATE_PDF,
  'api/v1/administrators/special_permits/pdf_settings/update',
  payload,
  callback,
);
